import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Contentsection(props) {
    return (
        <div className="tekrevol_contentsection p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <div className="example" data-text="POS Solutions">
                            <h2>On Point Payment Infrastructure</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
                        <p>Our POS developers have worked with niche-based businesses to create customized, integrated
                            POS systems to reshape their payment infrastructure. </p>
                        <p>We house a team of product strategists and professional technical developers, creative UI and
                            UX designers, and business analysts who work together to bring impactful solution ideas to
                            digital realities.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Contentsection;